import React, { useState, useContext, createContext, FC } from 'react';

interface ThemeProps {
  children: React.ReactNode;
}

const ThemeContext = createContext(null);

export function useTheme(): any {
  return useContext(ThemeContext);
}

const ThemeProvider: FC<ThemeProps> = ({ children }) => {
  const [dark, setDark] = useState(false);

  function setDarkTheme() {
    setDark(true);
  }

  function setLightTheme() {
    setDark(false);
  }

  const value: any = {
    dark,
    setDarkTheme,
    setLightTheme
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
